export default __webpack_public_path__ + "static/media/checkmark.bab1fcb7.ico";